import { QuarterCloseChecklistRowTitles } from '@shared/store/workflow/workflow-types';
import { Workflow } from '@shared/store/workflow/workflow.store';

export function workflow(
  rowId: QuarterCloseChecklistRowTitles,
  workflowList: Workflow[]
): Workflow {
  // Static values
  return workflowList.find((checklistWorkflow) => {
    return rowId === checklistWorkflow.name;
  })!;
}
